// extracted by mini-css-extract-plugin
module.exports = {"quantity_input":"quantity-input_quantity_input__UkQuw"};